import { useEffect, useState, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { subscribeToAiPreference, setAiPreference, clearAiData } from '@shared/services/userContentService';
import { useDemoMode } from '../demo/DemoContext';
import { logError } from '@/lib/log';

export function useAiPreference() {
    const { currentUser } = useAuth();
    const { isDemo } = useDemoMode();
    const [aiEnabled, setAiEnabledState] = useState(true);

    useEffect(() => {
        if (!currentUser?.uid || isDemo) {
            setAiEnabledState(true);
            return;
        }
        const unsubscribe = subscribeToAiPreference(currentUser.uid, (enabled) => {
            setAiEnabledState(enabled);
        });
        return unsubscribe;
    }, [currentUser?.uid, isDemo]);

    const setAiEnabled = useCallback(async (enabled: boolean) => {
        if (!currentUser?.uid || isDemo) return;
        setAiEnabledState(enabled);
        try {
            await setAiPreference(currentUser.uid, enabled);
            // When disabling, clear AI data (disclaimer acceptance, etc.)
            if (!enabled) {
                await clearAiData(currentUser.uid);
            }
        } catch (error) {
            logError(error, { context: 'save_ai_preference' });
            setAiEnabledState(!enabled); // Revert on failure
        }
    }, [currentUser?.uid, isDemo]);

    return { aiEnabled, setAiEnabled };
}
